import React from 'react';
import { Box, Card, Text } from '@nimbus-ds/components';
import { useStoreInfo } from 'commons/hooks';
import { MoneyObjectInterface } from 'commons/types';
import { formatCurrency, useTranslationWithPrefix } from 'commons/utils';
import BalanceCardSkeleton from './BalanceCardSkeleton';

interface BalanceCardProps {
  balance: MoneyObjectInterface;
}

function BalanceCard({ balance }: BalanceCardProps): JSX.Element {
  const { t } = useTranslationWithPrefix('transfer.balanceCard');
  const { storeInfo } = useStoreInfo();

  return (
    <Card>
      <Box display="flex" justifyContent="space-between" flexDirection="row">
        <Text>{t('available')}</Text>
        <Text color="primary-textHigh" fontWeight="bold" fontSize="highlight">
          {formatCurrency(balance, storeInfo)}
        </Text>
      </Box>
    </Card>
  );
}

BalanceCard.Skeleton = BalanceCardSkeleton;
export default BalanceCard;
